import { FC } from "react";
import { RentHiveContent } from "./style";
import { SharedHive } from "entities/hives/model/types";

type ModalContentProps = {
  findedShared: SharedHive | null;
  successShare: "" | "success";
};

export const ModalContent: FC<ModalContentProps> = ({
  findedShared,
  successShare,
}) => {
  if (
    findedShared &&
    !findedShared.reservationId &&
    successShare === ""
  ) {
    return (
      <>
        <RentHiveContent>
          <p>Этот улей доступен для сдачи в аренду</p>
        </RentHiveContent>
      </>
    );
  } else if (
    findedShared &&
    findedShared.reservationId &&
    successShare === ""
  ) {
    return (
      <>
        <RentHiveContent>
          <p>Этот улей сейчас арендован, поэтому снять его с аренды нельзя</p>
        </RentHiveContent>
      </>
    );
  }

  return (
    <>
      <RentHiveContent>
        <p>
          {successShare === "success"
            ? "Вы можете в любой момент снять улей с аренды если он не сдается в данный момент"
            : "Вы можете сдать этот улей в аренду с помощью нашего сервиса аренды ульев"}
        </p>
      </RentHiveContent>
    </>
  );
};
